


































































import { Vue, Component, Prop } from 'vue-property-decorator'
import * as _ from 'underscore'
import showDiv, { closeAll } from '@ivy/fts/showDiv'
@Component({
  components: {},
})
export default class TestPage extends Vue {
  @Prop({ default: [] }) info: any[]
  testInfo = this.info.map(i => ({
    ...i,
    answers: new Array(i.subjects.length).fill(null),
  }))
  showNum = 1
  currentIndex = 0
  scroll
  transitionName = 'turn-on'
  get showPre() {
    return this.currentIndex !== 0
  }
  get canClickNext() {
    let answers = this.testInfo[this.currentIndex].answers
    return answers.every(answer => [0, 1].includes(answer))
  }
  get nextBtnSrc() {
    if (!this.canClickNext)
      return this.currentIndex + 1 === this.testInfo.length
        ? require('./imgs/commit_btn_disable.png')
        : require('./imgs/next_btn_disable.png')
    return this.currentIndex + 1 === this.testInfo.length
      ? require('./imgs/commit_btn.png')
      : require('./imgs/next_btn.png')
  }
  mounted() {
    let scrollList: any = this.$refs.scrollList
    scrollList &&
      scrollList.style &&
      (scrollList.style.transform = `translateX(${-this.currentIndex * 100}vw)`)
  }
  goPre() {
    this.currentIndex--
  }
  goNext() {
    if (!this.canClickNext) return
    if (this.currentIndex + 1 === this.testInfo.length) {
      this.$emit('getResult', this.testInfo)
    } else {
      this.currentIndex++
    }
  }
}
